<template>
  <v-flex d-flex>
    <v-container fluid>
      <v-card class="px-2 pb-2 mb-3">
        <v-card-title primary-title>
          <span class="title">{{ $route.meta.title }}</span>
        </v-card-title>
        <v-slide-y-transition mode="out-in">
          <v-card-text class="pt-0">
            <v-form v-model="valid" ref="form" lazy-validation>
              <v-container fluid>
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-select
                      v-model="selectedKey"
                      :items="keys"
                      label="Key"
                      :menu-props="{ auto: true }"
                      prepend-icon="mdi-key"
                      required
                      :rules="[v => !!(v || '').trim() || 'Required']"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12>
                    <v-textarea
                      v-model="data"
                      label="Data"
                      prepend-icon="mdi-content-paste"
                      class="input-data"
                      required
                      :rules="[v => !!(v || '').trim() || 'Required']"
                    ></v-textarea>
                  </v-flex>
                  <v-flex xs12>
                    <v-btn color="primary" style="margin-left: 40px" @click="submit" :loading="loading">Encrypt</v-btn>
                  </v-flex>
                  <v-slide-y-transition mode="out-in">
                    <v-flex v-if="result" xs12 class="pt-3">
                      <v-textarea
                        :value="result"
                        label="Result"
                        outline
                      ></v-textarea>
                    </v-flex>
                  </v-slide-y-transition>
                </v-layout>
              </v-container>
            </v-form>
          </v-card-text>
        </v-slide-y-transition>
      </v-card>
    </v-container>
  </v-flex>
</template>

<script>
  import MongoService from '../services/mongo.service'

  export default {
    data () {
      return {
        loading: false,
        valid: true,
        selectedKey: null,
        data: '',
        keys: [],
        result: null
      }
    },
    async beforeMount () {
      this.loading = true
      try {
        this.keys = await MongoService.encryption.listKeys()
        this.selectedKey = this.keys[0]
      } catch (e) {}
      this.loading = false
    },
    methods: {
      async submit () {
        if (!this.$refs.form.validate()) return
        this.loading = true
        this.result = null
        try {
          const result = await MongoService.encryption.encrypt({
            key: this.selectedKey,
            data: this.data
          })
          this.result = result
        } catch (e) {}
        this.loading = false
      }
    }
  }
</script>
